import * as types from '../actions/types';
import * as request from '../utils/request';
import mergeRequestsWrapper from './mergeRequestsWrapper'
import toastr from 'toastr';

export function getCoursesSuccess(courses) {
  return {
    type: types.GET_COURSES_SUCCESS,
    payload: courses
  };
}

export function getCrosslistSuccess(crosslists) {
  return {
    type: types.GET_CROSSLIST_SUCCESS,
    payload: crosslists
  };
}

export function getCourseByIdSuccess(course) {
  return {
    type: types.GET_COURSE_BY_ID_SUCCESS,
    payload: course
  };
}

export function getCourseRankingsSuccess(rankings) {
  return {
    type: types.GET_COURSE_RANKINGS_SUCCESS,
    payload: rankings
  };
}

export const getAllCourses = mergeRequestsWrapper(function getAllCourses() {
  let runName = localStorage.getItem('run');
  let courses = [];

  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      function getCourses(url) {
        request
          .req('GET', url)
          .then(res => {
            res.data.results.forEach(course => {
              courses.push(course);
            });
            if (res.data.next == null) {
              dispatch(getCoursesSuccess(courses));
              return resolve();
            } else {
              getCourses(res.data.next);
            }
          })
          .catch(err => {
            console.log('err', err);
            return reject();
          });
      }
      getCourses('/runs/' + runName + '/courses/');
    });
  };
})

export function getCourseById(id) {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('GET', '/runs/' + runName + '/courses/' + id + '/')
        .then(res => {
          dispatch(getCourseByIdSuccess(res.data));
          return resolve();
        })
        .catch(() => {
          return reject();
        });
    });
    return promise;
  };
}

export function putCourse(obj) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('PUT', '/runs/' + runName + '/courses/' + obj.id + '/', obj)
        .then(() => {
          toastr.success('Item Changed Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('error', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function deleteCourse(id) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('DELETE', '/runs/' + runName + '/courses/' + id + '/')
        .then(() => {
          toastr.success('Item Deleted Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('error', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function createCourse(obj) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/courses/', obj)
        .then(res => {
          toastr.success('Item Added Successfully.');
          return resolve(res.data);
        })
        .catch(err => {
          console.log('error', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function getCourseRankings(courseId) {
  let runName = localStorage.getItem('run');
  return (dispatch, getState) => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('GET', `/runs/${runName}/courses/${courseId}/preferences/`)
        .then(res => {
          // Get the students array from state
          const students = getState().students || [];
          
          // Process the data and transform it for the UI
          const rankings = res.data.results.map(preference => {
            // Try to find the student in the students array
            const student = students.find(s => s.id === preference.student);
            
            return {
              student_email: student ? student.user.email : null,
              student_id: preference.student,
              rank: preference.preference_class === 0 ? 'Favorite' : 
                   preference.preference_class === 1 ? 'Great' : 
                   preference.preference_class === 2 ? 'Good' : 'Acceptable',
              score: preference.score
            };
          });
          
          // Sort by rank (Favorite first, then Great, etc.) and then by score within each rank
          rankings.sort((a, b) => {
            const rankOrder = { 'Favorite': 0, 'Great': 1, 'Good': 2, 'Acceptable': 3 };
            const rankDiff = rankOrder[a.rank] - rankOrder[b.rank];
            
            // If same rank, sort by score (highest first)
            if (rankDiff === 0) {
              return b.score - a.score;
            }
            
            return rankDiff;
          });
          
          dispatch(getCourseRankingsSuccess(rankings));
          return resolve(rankings);
        })
        .catch(err => {
          console.log('Error fetching course rankings:', err);
          return reject();
        });
    });
    return promise;
  };
}

export function addNewMeeting(classId, obj) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/courses/' + classId + '/meetings/', obj)
        .then(() => {
          toastr.success('Item Added Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}
export function putMeeting(classId, obj) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('PUT', '/runs/' + runName + '/courses/' + classId + '/meetings/' + obj.id + '/', obj)
        .then(() => {
          toastr.success('Item Edited Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function deleteMeeting(classId, id) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('DELETE', '/runs/' + runName + '/courses/' + classId + '/meetings/' + id + '/')
        .then(() => {
          toastr.success('Item Deleted Successfully.');
          return resolve();
        })
        .catch(() => {
          toastr.error('Something gone wrong.');
          return reject();
        });
    });
    return promise;
  };
}

export function addNewCrosslist(classId, obj) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/courses/' + classId + '/crosslists/', obj)
        .then(() => {
          toastr.success('Item Added Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function putCrosslist(classId, obj) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('PUT', '/runs/' + runName + '/courses/' + classId + '/crosslists/' + obj.id + '/', obj)
        .then(() => {
          toastr.success('Item Changed Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function deleteCrosslist(classId, id) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('DELETE', '/runs/' + runName + '/courses/' + classId + '/crosslists/' + id + '/')
        .then(() => {
          toastr.success('Item Deleted Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function addNewDiscount(courseId, obj) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/courses/' + courseId + '/discounts/', obj)
        .then(() => {
          toastr.success('Item Added Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function putDiscount(courseId, obj) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('PUT', '/runs/' + runName + '/courses/' + courseId + '/discounts/' + obj.id + '/', obj)
        .then(() => {
          toastr.success('Item Changed Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function deleteDiscount(courseId, id) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('DELETE', '/runs/' + runName + '/courses/' + courseId + '/discounts/' + id + '/')
        .then(() => {
          toastr.success('Item Deleted Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function getDiscountlist(courseId) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
    request
      .req('GET', '/runs/' + runName + '/courses/' + courseId + '/discounts/')
      .then(res => {
        return resolve(res.data);
      })
      .catch(err => {
        console.log('err', err);
        return reject();

      });
    });
    return promise;
  };
}

export function getAssignmentlist(courseId) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
    request
      .req('GET', '/runs/' + runName + '/courses/' + courseId + '/assignments/')
      .then(res => {
        return resolve(res.data);
      })
      .catch(err => {
        console.log('err', err);
        return reject();

      });
    });
    return promise;
  };
}

export function getWaitlistlist(courseId) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
    request
      .req('GET', '/runs/' + runName + '/courses/' + courseId + '/waitlists/')
      .then(res => {
        return resolve(res.data);
      })
      .catch(err => {
        console.log('err', err);
        return reject();

      });
    });
    return promise;
  };
}

export function deleteExclusive(courseId, id) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('DELETE', '/runs/' + runName + '/courses/' + courseId + '/exclusives/' + id + '/')
        .then(() => {
          toastr.success('Item Deleted Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function addOrUpdateExclusive(url, method, obj) {

  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req(method, url, obj)
        .then((res) => {
          // toastr.success('Item Added Successfully.');
          return resolve(res.data);
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function addOrUpdateGroupsInExclusive(courseId, exclusiveId, obj) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/courses/' + courseId + '/exclusives/' + exclusiveId + '/groups/', obj)
        .then(() => {
          // toastr.success('Item Added Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function addOrUpdateCoReqsInExclusive(courseId, exclusiveId, obj) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/courses/' + courseId + '/exclusives/' + exclusiveId + '/coreqs/', obj)
        .then(() => {
          toastr.success('Item Added Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function getExclusives(courseId) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
    request
      .req('GET', '/runs/' + runName + '/courses/' + courseId + '/exclusives/')
      .then(res => {
        return resolve(res.data);
      })
      .catch(err => {
        console.log('err', err);
        return reject();

      });
    });
    return promise;
  };
}

export function getCoReqs(courseId) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
    request
      .req('GET', '/runs/' + runName + '/courses/' + courseId + '/coreqs/')
      .then(res => {
        return resolve(res.data);
      })
      .catch(err => {
        console.log('err', err);
        return reject();

      });
    });
    return promise;
  };
}

export function getGroupLocks(courseId) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
    request
      .req('GET', '/runs/' + runName + '/courses/' + courseId + '/group-locks/')
      .then(res => {
        return resolve(res.data);
      })
      .catch(err => {
        console.log('err', err);
        return reject();

      });
    });
    return promise;
  };
}

export function deleteGroupLock(courseId, id) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('DELETE', '/runs/' + runName + '/courses/' + courseId + '/group-locks/' + id + '/')
        .then(() => {
          toastr.success('Item Deleted Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function addGroupLock(courseId, obj) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
      .req('POST', '/runs/' + runName + '/courses/' + courseId + '/group-locks/', obj)
        .then(() => {
          toastr.success('Item Added Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function getCrosslist(classId) {
  let runName = localStorage.getItem('run');
  let crosslists = [];
  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      function getCs(url) {
        request
          .req('GET', url)
          .then(res => {
            res.data.results.forEach(c => {
              crosslists.push(c);
            });
            if (res.data.next == null) {
              dispatch(getCrosslistSuccess(crosslists));
              return resolve();
            } else {
              getCs(res.data.next);
            }
          })
          .catch(err => {
            console.log('err', err);
            return reject();
          });
      }
      getCs('/runs/' + runName + '/courses/' + classId + '/crosslists/');
    });
    return promise;
  };
}

export function runSatisfy(addId) {
  const runName = localStorage.getItem('run')
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', `/runs/${runName}/adds/${addId}/satisfy/`)
        .then(res => {
          return resolve(res.data)
        })
        .catch(function (err) {
          console.log('ERROR', err.message);
          toastr.error('Problem with schedules.');
          return reject();
        });
    })
    return promise
  }
}


export function addStudentsToWaitlist(courseId, studentsArray) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      let promises = studentsArray.map(student => {
        let obj = {
          course: courseId,
          student: student.id
        };
        return request.req('POST', '/runs/' + runName + '/adds/', obj);
      });
      Promise.all(promises)
        .then(() => {
          toastr.success('Student(s) assigned successfully');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('Error');
          return reject();
        });
    });
    return promise;
  };
}

export function addStudentsToCourse(courseId, studentsArray) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      let promises = studentsArray.map(student => {
        let obj = {
          course: courseId,
          student: student.id
        };
        return request.req('POST', '/runs/' + runName + '/assignments/', obj);
      });
      Promise.all(promises)
        .then(() => {
          toastr.success('Student(s) assigned successfully');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('Error');
          return reject();
        });
    });
    return promise;
  };
}

export const deleteAssignment = id => {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('DELETE', '/runs/' + runName + '/assignments/' + id + '/')
        .then(() => {
          toastr.success('Item Deleted Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('error', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
};

export const dropAssignment = assignmentId => {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', `/runs/${runName}/assignments/${assignmentId}/drop/`, null)
        .then(() => {
          dispatch({
            type: types.ASSIGNMENTS_DROP,
            payload: assignmentId
          })
          dispatch({
            type: types.ASSIGNMENTS_DELETE_ENTITY,
            payload: assignmentId
          })
          toastr.success('Your assignment dropped successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error. We cannot drop your assignment.');
          return reject();
        });
    });
    return promise;
  };
};

export const createAdd = id => {
  let runName = localStorage.getItem('run');

  return (dispatch) => {
    return new Promise((resolve, reject) => {
      request
        .req('POST', `/runs/${runName}/adds/`, {course: id})
        .then(res => {
          dispatch({
            type: types.ADD_WAITLIST_SUCCESS,
            payload: res.data
          });
          resolve(res.data);
        })
        .catch(err => {
          console.error(err)
          toastr.error('There was some error on creating add.');
          reject()
        })
    })
  }
}

export const deleteWaitlist = id => {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('DELETE', '/runs/' + runName + '/adds/' + id + '/')
        .then(() => {
          dispatch({
            type: types.DELETE_WAITLIST_SUCCESS,
            payload: id
          });
          toastr.success('Item Deleted Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('error', err);
          toastr.error('There was some error on delete waitlist.');
          return reject();
        });
    });
    return promise;
  };
};

export const bumpWaitlist = id => {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', `/runs/${runName}/adds/${id}/bump/`, null)
        .then(() => {
          toastr.success('Bump Successfully.');
          return resolve();
        })
        .catch(() => {
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
};

export const refreshValidity = id => {
  const runName = localStorage.getItem('run');
  return () => new Promise((resolve, reject) => {
    request
    .req('POST', `/runs/${runName}/adds/${id}/validity/`, null)
    .then((res) => {
      toastr.success('Validity is being checked.');
      let time = +localStorage.getItem('assignTime') || 1000;

      const checkStatus = (url) => {
        request.req('GET', url).then(res => {
          if (res.data.status === 'success') {
            toastr.success('Validity has been checked.');
            localStorage.removeItem('assignTime');
            localStorage.removeItem('assignUrl');
            return resolve();
          } else {
            if (time < 120000) {
              time += 1000;
              localStorage.setItem('assignTime', time);
              setTimeout(() => {
                checkStatus(url);
              }, 1000);
            } else {
              localStorage.removeItem('assignTime');
              localStorage.removeItem('assignUrl');
              
              toastr.error('Request timeout, please try again');
              return reject();
            }
          }
        })
      }

      localStorage.setItem('assignUrl', res.data.url);
      checkStatus(res.data.url);
    })
    .catch((err) => {
      toastr.error('There was some error.');
      return reject(err);
    })
  })
}

export const addToAutoDrop = ({addId, ids}) => {
  const runName = localStorage.getItem('run');

  return (dispatch) => request
    .req('POST', `/runs/${runName}/adds/${addId}/conditionaldrops/`, ids.map(assignment => ({ assignment })))
    .then(res => {
      dispatch({
        type: types.UPDATE_WAITLIST,
        payload: {
          id: addId,
          data: {
            conditional_drops: res.data
          }
        }
      })
      toastr.success('Auto drop has been updated.');
    })
    .catch(() => {
      toastr.error('There was some error.');
    })
}

export const changeGrading = (assignmentId, pass_fail) => {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    dispatch({
      type: types.ASSIGNMENTS_UPDATE_ENTITY,
      payload: { id: assignmentId, isOnGradingChange: true }
    })

    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', `/runs/${runName}/assignments/${assignmentId}/change-grading/`, { pass_fail })
        .then(response => {
          dispatch({
            type: types.ASSIGNMENTS_UPDATE_ENTITY,
            payload: { ...response.data, isOnGradingChange: false }
          })
          toastr.success('Your assignment grading changed successfully.');
          return resolve();
        })
        .catch(err => {
          dispatch({
            type: types.ASSIGNMENTS_UPDATE_ENTITY,
            payload: {id: assignmentId, isOnGradingChange: false}
          })
          console.log('err', err);
          toastr.error('There was some error. We cannot change your assignment grading.');
          return reject();
        });
    });
    return promise;
  };
};


// WEBPACK FOOTER //
// ./src/actions/coursesActionCreators.js